export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CHANGE_EMPLOYER = 'CHANGE_EMPLOYER';